import { makeStyles } from '@mui/styles';
import background from '../../../../Assets/images/faqBackground.png';
import mobBackground from '../../../../Assets/images/mobBackgroundFaq.svg';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  sectionMob: {
    // width: '100%',
    height: '100%',
    background: 'white',
    padding: '40px 20px',
    // [theme.breakpoints.down('xl')]: {
    //   padding: '40px 0px',
    // },
  },
  section: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-15px',
      left: 0,
      right: '-125px',
      bottom: 0,
      // backgroundImage: `url(${background})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top right',
      backgroundSize: '110%',
      zIndex: 1,
      pointerEvents: 'none',
    },
    '& > *': {
      position: 'relative',
      zIndex: 2,
    },
    [theme.breakpoints.down('xl')]: {
      width: '100%',
      margin: '0 auto',
      padding: '16px 0',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-15px',
        left: 0,
        right: '-125px',
        bottom: 0,
        backgroundImage: `url(${mobBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
        backgroundSize: '100%',
        zIndex: 1,
        pointerEvents: 'none',
      },
      '& > *': {
        position: 'relative',
        zIndex: 2,
      },
    },
  },
  content: {
    width: '90%',
  },
  heading: {
    fontFamily: 'Onest',

    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    lineHeight: '72px',
    marginBottom: '20px !important',
    alignSelf: 'flex-start',
    marginLeft: '5%',
    // background: 'linear-gradient(180deg, #FFF 25.69%, #999 121.53%)',
    // backgroundClip: 'text',
    // WebkitBackgroundClip: 'text',
    // WebkitTextFillColor: 'transparent',
    color: 'black',
    [theme.breakpoints.down('xl')]: {
      fontSize: '18px',
      letterSpacing: '-0.48px',
      textShadow: '0px 4px 28.9px rgba(255, 255, 255, 0.15)',
      background: 'none',
      WebkitBackgroundClip: 'unset',
      WebkitTextFillColor: 'unset',
      marginBottom: '4px !important',
      fontWeight: '600 !important',
    },
  },
  subheading: {
    fontFamily: 'Onest',
    fontSize: '14px',
    fontWeight: '400 !important',
    color: '#000',
    marginLeft: '5%',
    marginBottom: '20px !important',
    [theme.breakpoints.up('xl')]: {
      display: 'none !important',
    },
  },
  faqList: {
    // backgroundColor: '#F3F5FB',
    // marginTop: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px',
  },
  faqItem: {
    borderBottom: '1px solid #E8E8E8',
    paddingBottom: '16px',
  },
  questionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    paddingTop: '16px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  question: {
    display: 'flex',
    minWidth: '220px',
    flexDirection: 'column',
    alignItems: 'start',
    fontSize: '18px',
    fontWeight: '500 !important',
    color: '#000',
    [theme.breakpoints.down('xl')]: {
      minWidth: '20px',
      fontSize: '16px',
      fontWeight: '500 !important',
    },
  },
  iconBtn: {
    padding: '8px',
    borderRadius: '50%',
    backgroundColor: 'transparent',
  },

  iconImage: {
    width: '24px',
    height: '24px',
  },
  answer: {
    fontFamily: 'Onest',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400 !important',
    lineHeight: '24px',
    color: '#000',
    marginTop: '10px !important',
    [theme.breakpoints.down('xl')]: {
      fontSize: '14px',
      fontWeight: '300 !important',
    },
  },
}));
